import React, { useEffect, useState } from 'react';
import { Box, Modal, TextField, Button, Typography, CircularProgress } from '@mui/material';
import useSubmitForm from './useBudgetAndExpense';
import cancelHover from '../../assets/icons/delete (6) 1.png'
import cancel from '../../assets/icons/delete (7) 1.png'
import { formatCurrency } from '../utils/currencyFormatter';


const AddUserModal = ({ openExpenseModal, handleClose }) => {
  const { apiCall } = useSubmitForm(handleClose);
  const [loading, setLoading] = useState(false);

  const [formValues, setFormValues] = useState({});
  useEffect(() => {
    if (openExpenseModal?.data) {
      setFormValues({
        userName: openExpenseModal?.data?.advertiserName,
      })
    }
  }, [openExpenseModal])

  const handleDescription = (e) => {
    const description = e.target.value;
    setFormValues((prev) => ({
      ...prev,
      description: description,
    }));
  };
  const handleExpense = (e) => {
    if (!e || !e.target) return; // Check if e and e.target are defined

    let value = e.target.value;

    // Remove all non-digit and non-period characters
    value = value.replace(/[^\d.]/g, '');

    // Ensure that there's only one period in the value
    const parts = value.split('.');
    if (parts.length > 2) {
      value = `${parts[0]}.${parts.slice(1).join('')}`;
    }
    setFormValues((prev) => ({
      ...prev,
      userAmount: formatCurrency(Number(value)),
    }));
  };

  const handleKeyDown = (e) => {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab',
      'Control', 'v', 'V', 'c', 'C', 'a', 'A', '.'
    ];

    const isCtrlKey = e.ctrlKey || e.metaKey; // For Mac users using Command key

    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key) && !isCtrlKey) {
      e.preventDefault();
    }
    if (e.key === '.' && e.target.value.includes('.')) {
      e.preventDefault();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const expenseData = {
      type: "expense",
      advertiserName: openExpenseModal?.data?.advertiserName,
      advertiserId: openExpenseModal?.data?.advertiserId,
      value: parseFloat(formValues.userAmount.replace(/,/g, '')),
      description: formValues.description,
    };
    apiCall(expenseData, openExpenseModal?.data?.id)
      .finally(() => {
        setLoading(false);
        window.location.reload();
      });
    // apiCall(expenseData,openExpenseModal?.data?.id)
  };

  return (
    <Modal BackdropProps={{ sx: { backgroundColor: '#EEEEEE' } }} open={openExpenseModal?.open} onClose={() => handleClose()}>
      <Box className='border' sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '100%',
        boxShadow: 24,
        px: 24,
        py: 8,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}>

        <Box
          sx={{
            position: 'absolute',
            top: 90,
            right: 226,
            cursor: 'pointer',
          }}
          onClick={handleClose}
        >
          <img
            src={cancel}
            alt="cancel"
            // className="h-10"
            onMouseOver={(e) => e.currentTarget.src = cancelHover}
            onMouseOut={(e) => e.currentTarget.src = cancel}
            onClick={handleClose}
          />
        </Box>
        <Box sx={{
          border: "1px solid #1C4645",
          p: 10,
          borderRadius: 10
        }}
        >

          <form onSubmit={handleSubmit} sx={{ border: '1px solid #ccc' }}>

            {/* First row */}

            <Box sx={{ border: '1px solid #ccc', px: 4, py: 4 }}>
              <TextField
                id="advertiser-name"
                name="Advertiser Name"
                disabled
                label="Advertiser Name"
                value={formValues.userName}

                fullWidth
                inputProps={{ style: { fontSize: 16 } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 16 } }}
              />
            </Box>

            {/* Second row */}

            <Box sx={{ display: 'flex', alignItems: 'center', px: 4, py: 4, border: '1px solid #ccc' }}>
              <TextField
                id="add-new-expense"
                label="Add New Expense"
                name="Add New Expense"
                value={formValues.userAmount || '0'}
                onChange={(e) => handleExpense(e)} // Pass event object
                onKeyDown={handleKeyDown}
                onPaste={(e) => {
                  const paste = (e.clipboardData || window.clipboardData).getData('text');
                  if (!/^\d*\.?\d*$/.test(paste)) {
                    e.preventDefault();
                  }
                }}
                variant="outlined"
                fullWidth
              />
            </Box>

            {/* Third row */}
            <Box sx={{ border: '1px solid #ccc', px: 4, py: 4 }}>
              <TextField
                id="description"
                name="Description"
                variant="outlined"
                label="Description"
                // value={formValues.description}
                onChange={(e) => handleDescription(e)}
                required
                fullWidth
                inputProps={{ style: { fontSize: 16 } }} // font size of input text
                InputLabelProps={{ style: { fontSize: 16 } }}
              />
            </Box>

            {/* fourth row */}


            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mt: 8 }}>
              <Button
                variant="outlined"
                sx={{
                  borderColor: '#1C4645',
                  color: '#1C4645',
                  '&:hover': {
                    backgroundColor: '#1C4645',
                    color: 'white',
                    borderColor: '#1C4645',
                  },
                }}
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  backgroundColor: '#1C4645',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: 'white',
                    borderColor: '#1C4645',
                    color: '#1C4645',
                  },
                  ml: 2,
                }}
                // onClick={() =>handleSubmit()}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} color="inherit" sx={{ color: 'white' }} /> : 'Save'}
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddUserModal;